import { showSuccessAlert, lt } from '@mews/framework';
import { useLanguageCode } from '@mews-commander/core';
import { AssistantUserPromptLog, useRepositoryMutation } from '@mews-commander/data-access';

export const useRemoveRecentQuery = (recent: AssistantUserPromptLog) => {
    const languageCode = useLanguageCode();
    return useRepositoryMutation('assistantUserPrompts', 'removeRecentById', {
        transformParams: (params) => ({ ...params, languageCode }),
        invalidateQueries: { assistantUserPrompts: ['getRecents'] },
        onSuccess: (_data) => {
            showSuccessAlert({ description: lt('AssistantRecentRemoved', { searchTerm: recent.prompt }) });
        },
    });
};

export const useRemoveRecentByPromptQuery = (recent: AssistantUserPromptLog) => {
    const languageCode = useLanguageCode();
    return useRepositoryMutation('assistantUserPrompts', 'removeRecentByPrompt', {
        transformParams: (params: { prompt: string }) => ({ ...params, languageCode }),
        invalidateQueries: { assistantUserPrompts: ['getRecents'] },
        onSuccess: (_data) => {
            showSuccessAlert({ description: lt('AssistantRecentRemoved', { searchTerm: recent.prompt }) });
        },
    });
};
